import { string, func, node, bool } from "prop-types";
import { BreakdownTableDepths, Tables } from "@repo/utils";
import { CELL_WIDTHS } from "@utils";
import {
  useEstimateEditorSettings,
  useEstimateTableSettings,
  ElementChatPopup,
  PinnableCell,
  RowGroup,
  Row,
  ExpandContainer, VisibilityButton, useEstimateEditorStore, useVisibilityModeCellClassName
} from "@tools";
import { TitleInput } from "./TitleInput";

export const RowContainer = ({
  title,
  inputPlaceholder,
  commentPath,
  onTurnOffChange,
  onVisibilityChange,
  onNameChange,
  children,
  turnOff,
  isHidden,
  useDragHandleCell,
  actions,
}) => {
  const { visibilityMode } = useEstimateEditorStore();
  const { useProfitability, showChatThread, useVisibilityCell } = useEstimateEditorSettings();
  const { useExpandCell } = useEstimateTableSettings();
  
  const className = useVisibilityModeCellClassName(isHidden);
  
  return (
    <RowGroup
      originTableId={Tables.SUMMARY}
      tableDepth={BreakdownTableDepths.MODULE}
      isStatic
      presetClass="preset-accentSummary"
      className={className}
    >
      <Row
        tableDepth={BreakdownTableDepths.MODULE}
        isLastGroupRow
        isFirstGroupRow
        visible={!turnOff}
        onVisibilityToggle={onTurnOffChange}
        noArrow
        useDragHandleCell={useDragHandleCell}
        useVisibilityCell={useVisibilityCell}
        presetClass="preset-rowSummary"
        actionPresetClass="preset-paper"
      >
        <PinnableCell
          boldText keepMinSize
          minWidth={useProfitability ? CELL_WIDTHS.TITLE_SUMMARY_EMPTY : CELL_WIDTHS.TITLE_SUMMARY}
          pinnedLeft
          allowOverflowDisplay
          tableDepth={BreakdownTableDepths.MODULE}
          actions={actions || <>
            {
              showChatThread && commentPath && !useProfitability &&
              <ElementChatPopup
                rowThread
                path={ commentPath }
                taskName={title}
              />
            }
            {
              visibilityMode &&
              <VisibilityButton
                hidden={isHidden}
                onChange={onVisibilityChange}
                inRow
              />
            }
          </>}
          containers={
            useExpandCell &&
            <ExpandContainer noArrow />
          }
          pinActionsLeft
          actionsContainerWidth={6*24}
        >
          <TitleInput
            title={title}
            onChange={onNameChange}
            placeholder={inputPlaceholder}
          />
        </PinnableCell>
        { children }
      </Row>
    </RowGroup>
  );
};

RowContainer.propTypes = {
  title: string.isRequired,
  inputPlaceholder: string.isRequired,
  commentPath: string,
  onTurnOffChange: func.isRequired,
  onVisibilityChange: func,
  onNameChange: func.isRequired,
  children: node.isRequired,
  turnOff: bool.isRequired,
  isHidden: bool,
  useDragHandleCell: bool,
  actions: node,
}